import { DatePipe } from '@angular/common';
import { Temporal } from '@js-temporal/polyfill';
import { DepartureArrivalTime } from '@ridango/core';

export class TimeFilterUtil {
    /**
     * Check if time filter is actively set (future time selected)
     * @param filterTime Current filter time
     * @param timezone Timezone for comparison
     * @returns True if filter time is in the future
     */
    static isTimeFilterActive(filterTime: DepartureArrivalTime, timezone: string): boolean {
        if (!filterTime?.datetime) {
            return false;
        }

        const now = Temporal.Now.zonedDateTimeISO(timezone).round({ smallestUnit: 'minute' });
        const selected = Temporal.PlainDateTime.from(filterTime.datetime)
            .toZonedDateTime(timezone)
            .round({ smallestUnit: 'minute' });

        return now.epochSeconds < selected.epochSeconds;
    }

    /**
     * Format time filter for display label
     * @param filterTime Current filter time
     * @param format Date format string
     * @param datePipe Angular DatePipe instance
     * @returns Formatted time string
     */
    static formatTimeLabel(filterTime: DepartureArrivalTime, format: string, datePipe: DatePipe): string {
        const plainDateTime = Temporal.PlainDateTime.from(filterTime.datetime).toString();
        return datePipe.transform(plainDateTime, format);
    }

    /**
     * Get minimum date for filter (current date/time)
     * @param timezone Timezone for date calculation
     * @returns ISO string of current date/time
     */
    static getMinDateForFilter(timezone: string): string {
        return Temporal.Now.zonedDateTimeISO(timezone).toString({
            smallestUnit: 'second',
            timeZoneName: 'never'
        });
    }

    /**
     * Get maximum date for filter (end of current year + 1)
     * @param timezone Timezone for date calculation
     * @returns ISO string of max date
     */
    static getMaxDateForFilter(timezone: string): string {
        return Temporal.Now.plainDateISO(timezone).add({ years: 1 }).with({ month: 12, day: 31 }).toString();
    }
}
